export default "__VITE_ASSET__DALcEC6y__"